@if (datasets.length) {
  <div class="chart-row">
    <div class="chart-canvas-wrap">
      <canvas
        baseChart
        [type]="'line'"
        [data]=initialChartData
        [options]=chartOptions
      ></canvas>
    </div>

    @if (datasets.length > 1) {
      <div class="legend">
        @for (item of legendItems; track item.tile.ID) {
          <div class="legend-item">
            <span class="swatch" [style.background]="item.color">
              <motn-fa-icon [icon]="'fa-regular fa-' + item.tile.Appearance.Icon"></motn-fa-icon>
            </span>
            <div class="legend-text">
              <span class="name" [title]="item.tile.displayName">{{ item.tile.displayName }}</span>
              @if (item.tile.facetValues.length > 0) {
                <div class="facets">
                  @for (val of item.tile.facetValues; track $index) {
                    @if (!$first) {<i class="fa-solid fa-circle-dot"></i>}
                    <span>{{ val }}</span>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
